import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '@/utils/lib/axios';
import { env } from '@/utils/constants/env';
import type { GenerateAIResponse } from '@/types/generate-ai';
import type { BusinessGoalAIGenerateFormData } from './business-goal-ai-generate.schema';

interface UseGenerateBusinessGoalOptions {
  tenantId: string;
}

export const useGenerateBusinessGoal = ({ tenantId }: UseGenerateBusinessGoalOptions) => {
  return useMutation<GenerateAIResponse, Error, BusinessGoalAIGenerateFormData>({
    mutationFn: async (data: BusinessGoalAIGenerateFormData) => {
      try {
        const response = await axiosInstance.post<GenerateAIResponse>(
          `${env.apiTasklistBaseUrl}/api/v1/compro/${tenantId}/ai/generate-businessgoal`,
          data,
        );
        return response.data;
      } catch (error: any) {
        const message = error.response?.data?.message || 'Failed to generate business goals';
        throw new Error(message);
      }
    },
  });
};
